export const changePedidoStatusToTag = (status) => {
  // if (status === 'PEDIDO_CANCELADO') {
  //   return 'Cancelado'
  // } else {
  //   return 'Efetuado'
  // }

  let tag = ''

  switch (status) {
    case 'PEDIDO_EM_TRANSPORTE':
      tag = 'Em transporte'
      break
    case 'PEDIDO_ENTREGUE':
      tag = 'Entregue'
      break
    case 'PEDIDO_CANCELADO':
      tag = 'Cancelado'
      break
    case 'AGUARDANDO_LIBERACAO':
      tag = 'Aguardando Liberação'
      break
    case 'AGUARDANDO_PAGAMENTO':
      tag = 'Aguardando Pagamento'
      break
    case 'AGUARDANDO_FECHAMENTO_B2B':
      tag = 'Aguardando Fechamento B2B'
      break
    case 'SEPARACAO_DE_PRODUTO':
      tag = 'Em separação'
      break
    case 'PEDIDO_EFETUADO':
      tag = 'Efetuado'
      break
    case 'DEVOLVIDO':
      tag = 'Devolvido'
      break
    case 'PROCESSAMENTO_PEDIDO':
      tag = 'Processando'
      break
    case 'EMISSAO_DE_NOTA_FISCAL':
      tag = 'Emissão de Nota Fiscal'
      break
    default:
      break
  }

  return tag
}

export const getPedidoStatusColor = (status) => {
  let color = ''

  switch (status) {
    case 'Negociação Avaliada':
      color = 'green'
      break
    case 'Avaliada':
      color = 'green'
      break
    case 'PEDIDO_CANCELADO':
      color = 'red'
      break
    case 'AGUARDANDO_LIBERACAO':
      color = 'green'
      break
    case 'AGUARDANDO_PAGAMENTO':
      color = 'green'
      break
    case 'AGUARDANDO_FECHAMENTO_B2B':
      color = 'green'
      break
    case 'SEPARACAO_DE_PRODUTO':
      color = 'green'
      break
    case 'PEDIDO_EFETUADO':
      color = 'green'
      break
    case 'DEVOLVIDO':
      color = 'green'
      break
    case 'PROCESSAMENTO_PEDIDO':
      color = 'green'
      break
    case 'EMISSAO_DE_NOTA_FISCAL':
      color = 'green'
      break
    default:
      break
  }

  return color
}

export const getSortedStatusByDate = (remessas, pedido) => {
  let array = []

  const trackingVazio =
    remessas !== undefined &&
    remessas[remessas.findIndex((x) => x.Tracking.length === 0)]

  if (trackingVazio !== undefined) {
    return pedido.StatusPedido
  } else {
    remessas?.map((seller) => {
      array.push(seller?.Tracking[seller.Tracking.length - 1])
    })

    const newArray = array.sort((a, b) => {
      return new Date(a.DataHoraMovimentacao) - new Date(b.DataHoraMovimentacao)
    })

    return newArray[0]?.PedidoSituacao
  }
}
